import { Box, Stack, Text } from "@chakra-ui/react";

import { BindingsImportPreviewType } from "@/codegen/openapi2";
import { Button } from "@/codegen/ui/button";
import { Checkbox } from "@/codegen/ui/checkbox";

type ImportValidationProps = {
  preview: BindingsImportPreviewType;
  areTransfersConfirmed: boolean;
  setAreTransfersConfirmed: (confirmed: boolean) => void;
  onValidate: () => void;
  isPending: boolean;
};
export const ImportValidation = ({
  preview,
  areTransfersConfirmed,
  setAreTransfersConfirmed,
  onValidate,
  isPending,
}: ImportValidationProps) => {
  const { transfer, creation, type_change, error } = preview.counts;
  const hasChanges = transfer + creation + type_change > 0;
  const canValidate = error === 0 && hasChanges && (transfer === 0 || areTransfersConfirmed);

  return (
    <Stack gap={4} align="flex-start">
      {transfer > 0 && (
        <Checkbox
          checked={areTransfersConfirmed}
          onCheckedChange={({ checked }) => setAreTransfersConfirmed(checked === true)}
          disabled={isPending}
        >
          Je confirme le transfert de {transfer} {transfer > 1 ? "communes" : "commune"}
        </Checkbox>
      )}
      <Text color="fg.muted">Les lignes sans type de zone sont importées en cœur de zone.</Text>
      <Box>
        <Button onClick={onValidate} disabled={!canValidate} loading={isPending}>
          Valider l'import
        </Button>
      </Box>
    </Stack>
  );
};
